<div (click)="onresourceClicked()" class="shadow-lg rounded-lg py-4 px-4 flex justify-between items-center gap-3 w-full  cursor-pointer hover:bg-gray-100" >
  <div class="grid download-resorce-item-ind gap-3 items-center">
    <ng-content select="[mediaIcon]"> </ng-content>
    <p>{{mediaTilte}} </p>
  </div>
  <mat-icon class="mdi mdi-download text-2xl text-primary"></mat-icon>
</div>
